{
  "version": 1,
  "asset_id": "f23970d0-54b0-4f68-9758-27c95386a5db",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/f23970d0-54b0-4f68-9758-27c95386a5db/loc-round-rock-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/f23970d0-54b0-4f68-9758-27c95386a5db/loc-round-rock-1280.webp",
  "original_filename": "loc-round-rock-1280.webp",
  "size": 131058,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:31Z"
}
